import * as React from "react";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, IconButton } from "@mui/material";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { TruncateText, delay } from "../functions/utilities/generic";
import dateFormat from "dateformat";
import toast from "react-hot-toast";
import { createBlogUrl } from "../functions/utilities/blogUrl";

export default function BlogCard({
  title,
  description,
  image,
  time,
  id,
  isUser,
}) {
  const navigate = useNavigate();
  const handleEdit = () => {
    navigate(`/blog-details/${id}`);
  };
  const handleDelete = async () => {
    try {
      const { data } = await axios.delete(`/api/v1/blog/delete-blog/${id}`);
      if (data?.success) {
        await delay(500);
        toast.success("Blog Deleted");
        await delay(500);
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
  };
  // const handleCardClick = (id) => {
  //     navigate(`/blog/${id}`);
  // };
  const handleCardClick = () => {
    navigate(`/blog/${createBlogUrl(title, id)}`);
  };

  return (
    <Card
      sx={{
        width: "100%",
        margin: "auto",
        mt: 2,
        padding: 2,
        boxShadow: "5px 5px 10px #ccc",
        ":hover": {
          boxShadow: "10px 10px 20px #ccc",
        },
      }}
    >
      {isUser && (
        <Box display={"flex"}>
          <IconButton onClick={handleEdit} sx={{ marginLeft: "auto" }}>
            <ModeEditIcon color="info" />
          </IconButton>
          <IconButton onClick={handleDelete}>
            <DeleteIcon color="error" />
          </IconButton>
        </Box>
      )}
      <CardMedia
        component="img"
        height="194"
        image={image}
        alt="Paella dish"
        // onClick={() => handleCardClick(id)}
        onClick={() => handleCardClick(id)}
      />
      <CardContent onClick={() => handleCardClick(id)}>
        <Typography variant="h6" color="text.secondary" noWrap>
          {title}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
            overflow: "hidden",
            lineHeight: "1.6em",
            maxHeight: "3.2em",
          }}
        >
          <TruncateText text={description} />
        </Typography>
        <br />
        <Typography variant="body1" color="text.secondary" component="h2">
          {dateFormat(time, "mmmm dS, yyyy HH:MM:ss")}
        </Typography>
      </CardContent>
    </Card>
  );
}
